import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  notification,
  Spin,
  Input,
  Space,
  Tooltip,
  Form,
  Row,
  Col,
  Modal as ModalAntd,
  Select,
  Divider,
} from 'antd';
import {
  SearchOutlined,
  TeamOutlined,
  ExclamationCircleOutlined,
  ContainerOutlined,
  ClearOutlined,
  EyeOutlined,
} from '@ant-design/icons';
import { getAccessTokenApi, logout } from '../../../../api/auth';
import Highlighter from 'react-highlight-words';
import { useHistory } from 'react-router';

import { getSuppliersFinancialApi } from '../../../../api/financial';
import useUser from '../../../../hooks/useUser';
import { deleteSupplierApi, getAllSuppliers } from '../../../../api/supplier';
import { METHOD_GET, ROL_MANAGER } from '../../../../utils/constants';
import AddSupplierForm from '../../Administration/SuppliersTable/AddSupplierForm';
import EditSupplierForm from '../../Administration/SuppliersTable/EditSupplierForm';
import Modal from '../../../General/Modal';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import {
  CERTIFICATIONS_CATALOG_ID,
  CITY_CATALOG_ID,
  OPERACIONES_CATALOG_ID,
  STATE_CATALOG_ID,
  UNIT_TYPE_CATALOG_ID,
  TYPE_OF_LOAD_CATALOG_ID,
  SERVICES_CATALOG_ID,
  HAZMAT_CATALOG_ID,
  TYPE_OF_SERVICE_CATALOG_ID,
  PACKAGING_UNIT_CATALOG_ID,
  MEASUREMENT_UNIT_CATALOG_ID,
  HAZMAT_VALUE_ID,
} from '../../../../helpers/constants';
import { fetchApi } from '../../../../helpers/fetch';
import { API_URL_CATALOG_VALUES } from '../../../../helpers/urls';
import { getCatalogValueHandle } from '../../../../helpers/handlerFunctionApi';

import './SuppliersTable.scss';
import useWindowDimensions from '../../../../hooks/useWindowdimensions';
import {
  formatPhoneNumber,
  messageErrorGeneral,
} from '../../../../utils/general';
import useMenuCollapse from '../../../../hooks/useMenuCollapse';

export default function SuppliersTable(props) {
  const {
    pickSupplier,
    setSupplierSelected: setSupplierSelectedPricing,
    form: formPricing,
    setModalIsVisible: setModalIsVisiblePricing,
    filterRate,
  } = props;
  const [reloadSuppliers, setReloadSuppliers] = useState(true);
  const [usersTable, setUsersTable] = useState([]);
  const [loadingForm, setLoadingForm] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const { person } = useUser();
  const history = useHistory();
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [titleModal, setTitleModal] = useState(false);
  const [contextModal, setContextModal] = useState(null);
  const [supplierSelected, setSupplierSelected] = useState(null);
  const { confirm } = ModalAntd;
  const token = getAccessTokenApi();
  const [form] = Form.useForm();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const { width } = useWindowDimensions();

  const [operationsCatalog, setOperationsCatalog] = useState([]);
  const [unitTypeCatalog, setUnitTypeCatalog] = useState([]);
  const [certificationsCatalog, setCertificationsCatalog] = useState([]);
  const [hazMatCatalog, setHazMatsCatalog] = useState([]);
  const [typeOfServiceCatalog, setTypeOfServiceCatalog] = useState([]);
  const [packagingCatalog, setPackagingCatalog] = useState([]);
  const [measurementUnitCatalog, setMeasurementUnitCatalog] = useState([]);
  const [servicesCatalog, setServicesCatalog] = useState([]);
  const [typeOfLoadCatalog, setTypeOfLoadCatalog] = useState([]);
  const [selectedrowKeys, setSelectedrowKeys] = useState([]);
  const { menuCollapsed } = useMenuCollapse();

  useEffect(() => {
    if (reloadSuppliers) {
      form.resetFields();
      if (filterRate) {
        if (Object.entries(filterRate).length !== 0) {
          filterSupplier(
            '1',
            filterRate.operation,
            filterRate.certificationsArray,
            filterRate.unit || filterRate.equipmentType,
            filterRate.typeOfLoad,
            filterRate.service,
            filterRate.typeOfService,
            '', //   filterRate.measurementUnit,
            '', //filterRate.packaging,
            filterRate.typeOfLoad === HAZMAT_VALUE_ID ? filterRate.hazMat : ''
            // filterRate.state,
            // filterRate.city,
            // filterRate.name,
            // filterRate.supplierId
          );
          form.setFieldsValue({
            operationsArray: filterRate.operation,
            unitsArray: filterRate.unit || filterRate.equipmentType,
            typeOfLoadArray: filterRate.typeOfLoad,
            servicesArray: filterRate.service,
            typeOfServiceArray: filterRate.typeOfService,
            measurementUnitArray: filterRate.measurementUnit,
            packagingArray: filterRate.packaging,
            hazMatArray:
              filterRate.typeOfLoad === HAZMAT_VALUE_ID
                ? filterRate.hazMat
                : '',
          });
        } else {
          filterSupplier('0');
        }
      } else {
        filterSupplier('0');
      }
    }
  }, [reloadSuppliers, person]);

  function filterSupplier(
    type,
    operation,
    certification,
    unit,
    typeOfLoad,
    service,
    typeOfService,
    measurementUnit,
    packaging,
    hazmat,
    state,
    city,
    name,
    supplierId
  ) {
    setLoadingForm(true);
    let filters = '';
    if (type !== '0') {
      filters = `?Certification=${
        certification !== undefined ? certification : ''
      }&Unit=${unit !== undefined ? unit : ''}&Operation=${
        operation !== undefined ? operation : ''
      }&LoadType=${typeOfLoad !== undefined ? typeOfLoad : ''}&Service=${
        service !== undefined ? service : ''
      }&TypeOfService=${
        typeOfService !== undefined ? typeOfService : ''
      }&MeasurementUnit=${
        measurementUnit !== undefined ? measurementUnit : ''
      }&Packaging=${packaging !== undefined ? packaging : ''}&HazMat=${
        hazmat !== undefined ? hazmat : ''
      }&CYState=${state !== undefined ? state : ''}&CYCity=${
        city !== undefined ? city : ''
      }&Name=${name !== undefined ? name : ''}&SupplierId=${
        supplierId !== undefined ? supplierId : ''
      }`;
    }
    if (person?.roles.includes(ROL_MANAGER)) {
      getAllSuppliers(token, filters).then((response) => {
        if (response === undefined) {
          notification['error']({
            message: 'Ocurrió un error, Inténtelo más tarde',
          });
          return false;
        }
        if (response.statusCode === 200) {
          response.result.forEach((element, index) => {
            element['key'] = index;
          });
          setUsersTable(response.result);
        } else {
          if (response.statusCode === 401) {
            notification['error']({
              message: 'Usuario no autorizado',
            });

            setTimeout(() => {
              logout();
              window.location.reload();
            }, 1500);
            return;
          }

          notification['error']({
            message: messageErrorGeneral(),
          });

          return;
        }
        setReloadSuppliers(false);
        setLoadingForm(false);
      });
    } else {
      getSuppliersFinancialApi(token, person.idUser, filters).then(
        (response) => {
          if (response) {
            if (response.statusCode === 401) {
              notification['error']({
                message: 'Usuario no autorizado',
              });

              setTimeout(() => {
                logout();
                window.location.reload();
              }, 1500);
              return;
            }
            if (response.statusCode === 200) {
              response.result.forEach((element, index) => {
                element['key'] = index;
              });
              setUsersTable(response.result);
            }
            setReloadSuppliers(false);
          }
        }
      );
    }
  }

  useEffect(() => {
    setLoadingForm(true);
    const config = {
      method: METHOD_GET,
      url: `${API_URL_CATALOG_VALUES}/GetAll/${STATE_CATALOG_ID}`,
      data: null,
      token,
      // showNotification: true
    };
    fetchApi(config)
      .then((response) => {
        if (response) {
          let calogsValues = response.result;

          if (calogsValues) {
            calogsValues.map((cat, index) => {
              cat['key'] = index;
              cat['label'] = cat.description;
              cat['value'] = cat.id;
            });
          }
          setStates(calogsValues);
        }
      })
      .catch((err) => {
        console.log(err);
      });
    getCatalogValueHandle(
      OPERACIONES_CATALOG_ID,
      setOperationsCatalog,
      setLoadingForm
      // form.getFieldValue('operationsArray')
    );
    getCatalogValueHandle(
      UNIT_TYPE_CATALOG_ID,
      setUnitTypeCatalog,
      setLoadingForm
    );
    getCatalogValueHandle(
      CERTIFICATIONS_CATALOG_ID,
      setCertificationsCatalog,
      setLoadingForm
    );
    getCatalogValueHandle(HAZMAT_CATALOG_ID, setHazMatsCatalog, setLoadingForm);
    getCatalogValueHandle(
      TYPE_OF_SERVICE_CATALOG_ID,
      setTypeOfServiceCatalog,
      setLoadingForm
    );
    getCatalogValueHandle(
      PACKAGING_UNIT_CATALOG_ID,
      setPackagingCatalog,
      setLoadingForm
    );
    getCatalogValueHandle(
      MEASUREMENT_UNIT_CATALOG_ID,
      setMeasurementUnitCatalog,
      setLoadingForm
    );
    getCatalogValueHandle(
      SERVICES_CATALOG_ID,
      setServicesCatalog,
      setLoadingForm
    );
    getCatalogValueHandle(
      TYPE_OF_LOAD_CATALOG_ID,
      setTypeOfLoadCatalog,
      setLoadingForm
    );
    setLoadingForm(false);

    //   getStateCatalogHandle();
  }, [reloadSuppliers]);
  const onChangeState = (value) => {
    getCatalogValueHandle(CITY_CATALOG_ID, setCities, setLoadingForm, value);
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            // this.searchInput = node;
          }}
          placeholder={`Buscar`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type='primary'
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size='small'
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => {
              handleReset(clearFilters);
              handleSearch(selectedKeys, confirm, dataIndex);
            }}
            size='small'
            style={{ width: 90 }}
          >
            Limpiar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : '',
    filteredValue: filteredInfo[dataIndex] || null,
    onFilterDropdownVisibleChange: (visible) => {},
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });
  const checkUser = (id) => {
    if (supplierSelected === id) {
      setSupplierSelected(null);
    } else {
      setSupplierSelected(id);
    }
  };
  const columns = [
    {
      title: 'Selecciona',
      ellipsis: true,
      width: pickSupplier ? 0 : 100,
      // width: 100,
      dataIndex: 'supplierId',
      key: 'company',
      render: (supplierId) => (
        <Checkbox
          // type="primary"                    {sectionContacts?.find((sc) => sc.sectionId === id)?.name}

          // disabled={
          //     !suppliersTable?.find(
          //         (st) => st.supplierId === supplierId
          //     )?.active
          // }
          onChange={() => checkUser(supplierId)}
          checked={supplierSelected === supplierId}
          className='button-detail'
        ></Checkbox>
      ),
      ellipsis: true,
    },
    {
      title: 'ID proveedor',
      ellipsis: true,
      dataIndex: 'supplierId',
      key: 'supplierId',
      ...getColumnSearchProps('supplierId'),
      render: (supplierId) => supplierId?.split('-')[0],
      width: 150,
    },
    {
      title: 'Nombre(s)',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      ellipsis: true,
      width: 150,
    },
    {
      title: 'RFC',
      dataIndex: 'fiscalID',
      key: 'fiscalID',
      ...getColumnSearchProps('fiscalID'),
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Teléfono',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      ...getColumnSearchProps('phoneNumber'),
      ellipsis: true,
      width: 150,
      render: (phoneNumber) => <span>{formatPhoneNumber(phoneNumber)}</span>,
    },
    {
      title: 'Correo electrónico',
      dataIndex: 'emailAddress',
      key: 'emailAddress',
      ...getColumnSearchProps('emailAddress'),
      ellipsis: true,
      width: 250,
    },
    {
      title: 'Contactos',
      key: 'contacts',
      fixed: 'right',
      ellipsis: true,
      width: pickSupplier ? 0 : 80,
      align: 'center',
      render: (supplier, supplierId) => (
        <>
          <Tooltip title='Contactos'>
            <Button
              style={{ marginLeft: 2 }}
              type='primary'
              shape='default'
              icon={<TeamOutlined />}
              onClick={() =>
                history.push(`/proveedores/contactos/${supplier.supplierId}`)
              }
            />
          </Tooltip>
        </>
      ),
    },
    {
      title: 'Patio',
      key: 'yard',
      fixed: 'right',
      ellipsis: true,
      width: pickSupplier ? 0 : 50,
      align: 'center',
      render: (supplier, supplierId) => (
        <>
          <Tooltip title='Patio'>
            <Button
              style={{ marginLeft: 2 }}
              type='primary'
              shape='default'
              icon={<ContainerOutlined />}
              onClick={() =>
                history.push(`/proveedores/patio/${supplier.supplierId}`)
              }
            />
          </Tooltip>
        </>
      ),
    },
    {
      title: 'Ver',
      key: 'sup',
      fixed: 'right',
      width: pickSupplier ? 0 : 50,
      align: 'center',
      render: (supplier) => (
        <>
          <Tooltip title='Ver más información'>
            <Button
              style={{ marginLeft: 10 }}
              type='primary'
              ghost
              shape='default'
              icon={<EyeOutlined />}
              onClick={() => showModal('Watch', supplier)}
            />
          </Tooltip>
        </>
      ),
    },
  ];
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters, selectedKeys, confirm, dataIndex) => {
    clearFilters();
    setSearchText('');
  };
  const handleChange = (pagination, filters, sorter, extra) => {
    setFilteredInfo(filters);
  };
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log(
      //     `selectedRowKeys: ${selectedRowKeys}`,
      //     'selectedRows: ',
      //     selectedRows
      // );
      setSupplierSelectedPricing(selectedRows[0]);
      setSelectedrowKeys(selectedRowKeys);
      formPricing.setFieldsValue({
        supplier: selectedRows[0].name,
      });
      // setModalIsVisiblePricing(false);
    },
    // getCheckboxProps: (record) => ({
    //   disabled: record.name === 'Disabled User', // Column configuration not to be checked
    //   name: record.name,
    // }),
  };
  const showModal = (type, supplier) => {
    if (type === 'Add') {
      setModalIsVisible(true);
      setTitleModal('Agregar proveedor');
      setContextModal(
        <AddSupplierForm
          setModalIsVisible={setModalIsVisible}
          setReloadSuppliers={setReloadSuppliers}
        ></AddSupplierForm>
      );
    } else if (type === 'Edit') {
      if (supplierSelected !== null) {
        setModalIsVisible(true);

        setTitleModal('Editar proveedor');
        setContextModal(
          <EditSupplierForm
            setModalIsVisible={setModalIsVisible}
            setReloadSuppliers={setReloadSuppliers}
            idSupplier={supplierSelected}
          ></EditSupplierForm>
        );
      } else if (supplierSelected === null) {
        notification['error']({
          message: 'Debes seleccionar un proveedor',
        });
      }
    } else if (type === 'Watch') {
      setModalIsVisible(true);
      setTitleModal(`Proveedor ${supplier.name}`);
      setContextModal(
        <EditSupplierForm
          setModalIsVisible={setModalIsVisible}
          setReloadSuppliers={setReloadSuppliers}
          idSupplier={supplier.supplierId}
          type='watch'
        ></EditSupplierForm>
      );
    }
  };
  const handleDeleteSupplier = (id) => {
    if (supplierSelected !== null) {
      confirm({
        title: 'Desactivar proveedor',
        icon: <ExclamationCircleOutlined />,
        content:
          '¿Estás seguro que deseas desactivar el proveedor seleccionado?, no se podrá reactivar después',
        okText: 'Si',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          deleteSupplier(id);
        },
        onCancel() {},
      });
    } else {
      notification['error']({
        message: 'Debes seleccionar un proveedor a desactivar',
      });
    }
  };
  const deleteSupplier = async (id) => {
    const accessToken = getAccessTokenApi();
    const result = await deleteSupplierApi(accessToken, id);
    if (result?.statusCode === 409) {
      notification['error']({
        message: result.description,
      });
    }
    if (result?.statusCode === 405) {
      notification['error']({
        message: result.description,
      });
    }
    if (result?.statusCode === 404) {
      notification['error']({
        message: result.description,
      });
    }
    if (result?.statusCode === 200) {
      notification['success']({
        message: 'Proveedor desactivado exitosamente.',
      });
      setSupplierSelected(null);
    }
    setReloadSuppliers(true);
  };
  const onFinish = async (values) => {
    if (pickSupplier) {
      setSelectedrowKeys([]);
      setSupplierSelectedPricing(null);
      formPricing.setFieldsValue({
        supplier: null,
      });
    }
    filterSupplier(
      '1',
      values.operationsArray,
      values.certificationsArray,
      values.unitsArray,
      values.typeOfLoadArray,
      values.servicesArray,
      values.typeOfServiceArray,
      values.measurementUnitArray,
      values.packagingArray,
      values.hazMatArray,
      values.state,
      values.city,
      values.name,
      values.supplierId
    );
  };
  return (
    <div className='supplier-table'>
      <Form
        name='search-supplier'
        // layout='horizontal'
        layout='vertical'
        form={form}
        onFinish={onFinish}
        initialValues={{ active: true }}
      >
        {/* <Collapse> */}
        {/* <CollapsePanel header="Filtros" key="1"> */}
        <div>
          <Row gutter={16}>
            <Col
              lg={width < 1200 ? (!menuCollapsed ? 8 : 6) : 6}
              md={12}
              sm={12}
              xs={24}
            >
              <Form.Item label='Operaciones:' name='operationsArray'>
                <Select
                  disabled={pickSupplier}
                  placeholder='Selecciona una opción'
                  allowClear
                  showArrow
                  // style={{
                  //   minWidth: width > 576 ? 200 : '100%',
                  //   width: width > 576 ? 200 : '100%',
                  // }}
                >
                  {operationsCatalog.map((s) => (
                    <Select.Option key={s.value} value={s.value}>
                      {s.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col
              lg={width < 1200 ? (!menuCollapsed ? 8 : 6) : 6}
              md={12}
              xs={24}
            >
              <Form.Item label='Certificaciones:' name='certificationsArray'>
                <Select
                  placeholder='Selecciona una opción'
                  allowClear
                  showArrow
                  // style={{
                  //   minWidth: width > 576 ? 200 : '100%',
                  //   width: width > 576 ? 200 : '100%',
                  // }}
                >
                  {certificationsCatalog.map((s) => (
                    <Select.Option key={s.value} value={s.value}>
                      {s.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col
              lg={width < 1200 ? (!menuCollapsed ? 8 : 6) : 6}
              md={12}
              xs={24}
            >
              <Form.Item label='Unidades:' name='unitsArray'>
                <Select
                  allowClear
                  placeholder='Selecciona una opción'
                  disabled={pickSupplier}
                  showArrow
                  // style={{
                  //   minWidth: width > 576 ? 210 : '100%',
                  //   width: width > 576 ? 210 : '100%',
                  // }}
                >
                  {unitTypeCatalog.map((s) => (
                    <Select.Option key={s.value} value={s.value}>
                      {s.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* </Row> */}
            {/* <Row gutter={16}> */}
            <Col
              lg={width < 1200 ? (!menuCollapsed ? 8 : 6) : 6}
              md={12}
              xs={24}
            >
              <Form.Item label='Tipo de carga:' name='typeOfLoadArray'>
                <Select
                  disabled={pickSupplier}
                  placeholder='Selecciona una opción'
                  allowClear
                  showArrow
                  // style={{
                  //   minWidth: width > 576 ? 200 : '100%',
                  //   width: width > 576 ? 200 : '100%',
                  // }}
                >
                  {typeOfLoadCatalog.map((s) => (
                    <Select.Option key={s.value} value={s.value}>
                      {s.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col
              lg={width < 1200 ? (!menuCollapsed ? 8 : 6) : 6}
              md={12}
              xs={24}
            >
              <Form.Item label='Servicios:' name='servicesArray'>
                <Select
                  disabled={pickSupplier}
                  placeholder='Selecciona una opción'
                  allowClear
                  showArrow
                  // style={{
                  //   minWidth: width > 576 ? 200 : '100%',
                  //   width: width > 576 ? 200 : '100%',
                  // }}
                >
                  {servicesCatalog.map((s) => (
                    <Select.Option key={s.value} value={s.value}>
                      {s.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col
              lg={width < 1200 ? (!menuCollapsed ? 8 : 6) : 6}
              md={12}
              xs={24}
            >
              <Form.Item label='Tipo servicio:' name='typeOfServiceArray'>
                <Select
                  disabled={pickSupplier}
                  allowClear
                  placeholder='Selecciona una opción'
                  showArrow
                  // style={{
                  //   minWidth: width > 576 ? 210 : '100%',
                  //   width: width > 576 ? 210 : '100%',
                  // }}
                >
                  {typeOfServiceCatalog.map((s) => (
                    <Select.Option key={s.value} value={s.value}>
                      {s.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            {/* </Row> */}
            {/* <Row gutter={16}>
            <Col md={7} xs={24}>
              <Form.Item label='Tipo de unidad:' name='measurementUnitArray'>
                <Select
                  disabled={pickSupplier}
                  placeholder='Selecciona una opción'
                  allowClear
                  showArrow
                  style={{
                    minWidth: width > 576 ? 200 : '100%',
                    width: width > 576 ? 200 : '100%',
                  }}
                >
                  {measurementUnitCatalog.map((s) => (
                    <Select.Option key={s.value} value={s.value}>
                      {s.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col md={12} xs={24}>
              <Form.Item label='Embalaje:' name='packagingArray'>
                <Select
                  disabled={pickSupplier}
                  placeholder='Selecciona una opción'
                  allowClear
                  showArrow
                  style={{
                    minWidth: width > 576 ? 200 : '100%',
                    width: width > 576 ? 200 : '100%',
                  }}
                >
                  {packagingCatalog.map((s) => (
                    <Select.Option key={s.value} value={s.value}>
                      {s.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row> */}
            {/* <Row gutter={16}> */}
            <Col
              lg={width < 1200 ? (!menuCollapsed ? 8 : 6) : 6}
              md={12}
              xs={24}
            >
              <Form.Item label='Patio-sede estado:' name='CYState'>
                <Select
                  // disabled={disableAllInputs}
                  placeholder='Selecciona una opción'
                  showSearch
                  optionFilterProp='children'
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={onChangeState}
                  // style={{
                  //   minWidth: width > 576 ? 200 : '100%',
                  //   width: width > 576 ? 200 : '100%',
                  // }}
                >
                  {states.map((s) => (
                    <Select.Option key={s.value} value={s.value}>
                      {s.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col
              lg={width < 1200 ? (!menuCollapsed ? 8 : 6) : 6}
              md={12}
              xs={24}
            >
              <Form.Item label='Patio-sede ciudad:' name='CYCity'>
                <Select
                  // disabled={disableAllInputs}
                  placeholder='Selecciona una opción'
                  showSearch
                  optionFilterProp='children'
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  // style={{
                  //   minWidth: width > 576 ? 200 : '100%',
                  //   width: width > 576 ? 200 : '100%',
                  // }}
                >
                  {cities.map((s) => (
                    <Select.Option key={s.value} value={s.value}>
                      {s.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col
              lg={width < 1200 ? (!menuCollapsed ? 8 : 6) : 6}
              md={12}
              xs={24}
            >
              <Form.Item label='Id proveedor:' name='supplierId'>
                <Input
                  placeholder='Ingresa tu información'
                  // style={{
                  //   minWidth: width > 576 ? 210 : '100%',
                  //   width: width > 576 ? 210 : '100%',
                  // }}
                />
              </Form.Item>
            </Col>
            {/* </Row> */}
            {/* <Row gutter={16}> */}
            <Col
              lg={width < 1200 ? (!menuCollapsed ? 8 : 6) : 6}
              md={12}
              xs={24}
            >
              <Form.Item label='HAZ-MAT:' name='hazMatArray'>
                <Select
                  allowClear
                  placeholder='Selecciona una opción'
                  disabled={pickSupplier}
                  showArrow
                  // style={{
                  //   minWidth: width > 576 ? 200 : '100%',
                  //   width: width > 576 ? 200 : '100%',
                  // }}
                >
                  {hazMatCatalog.map((s) => (
                    <Select.Option key={s.value} value={s.value}>
                      {s.label}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col
              lg={width < 1200 ? (!menuCollapsed ? 8 : 6) : 6}
              md={12}
              xs={24}
            >
              <Form.Item label='Nombre:' name='name'>
                <Input
                  placeholder='Ingresa tu información'
                  // style={{
                  //   minWidth: width > 576 ? 200 : '100%',
                  //   width: width > 576 ? 200 : '100%',
                  // }}
                />
              </Form.Item>
            </Col>

            <Col
              md={24}
              xs={24}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                style={{ width: 150, marginBottom: 10 }}
                className='btn-enviar'
                htmlType='submit'
                icon={<SearchOutlined />}
              >
                Buscar
              </Button>
              <Button
                style={{ width: 150 }}
                className='btn-download'
                onClick={(e) => setReloadSuppliers(true)}
                icon={<ClearOutlined />}
              >
                Limpiar filtros
              </Button>
            </Col>
          </Row>
        </div>
        {/* </CollapsePanel> */}
        {/* </Collapse> */}
      </Form>
      <Divider></Divider>
      <Spin spinning={loadingForm} tip='Cargando...'>
        {!pickSupplier && (
          <Row style={{ marginTop: 10, marginBottom: 10 }}>
            <Col span={24}>
              <Button className='btn-download' onClick={() => showModal('Add')}>
                Agregar
              </Button>

              <Button
                className='btn-download'
                onClick={() => showModal('Edit')}
              >
                Editar
              </Button>
              <Button
                className='btn-download'
                onClick={() => handleDeleteSupplier(supplierSelected)}
              >
                Desactivar
              </Button>
            </Col>
          </Row>
        )}
        <Table
          onChange={handleChange}
          columns={columns}
          dataSource={usersTable}
          scroll={{ x: 500 }}
          loading={reloadSuppliers}
          rowSelection={
            !pickSupplier
              ? null
              : {
                  type: 'radio',
                  selectedRowKeys: selectedrowKeys,
                  ...rowSelection,
                }
          }
          footer={() => {
            return (
              <FooterTable
                pickSupplier={pickSupplier}
                setModalIsVisiblePricing={setModalIsVisiblePricing}
              />
            );
          }}
          // pagination={{ defaultPageSize: 5 }}
        />
        <Modal
          title={titleModal}
          visible={modalIsVisible}
          setIsVisible={setModalIsVisible}
          width={1000}
        >
          {contextModal}
        </Modal>
      </Spin>
    </div>
  );
}

function FooterTable({ pickSupplier, setModalIsVisiblePricing }) {
  return (
    <div className='footer-table'>
      {pickSupplier && (
        <Button
          type='primary'
          onClick={() => {
            setModalIsVisiblePricing(false);
          }}
        >
          Aceptar
        </Button>
      )}
    </div>
  );
}
